
<template lang="pug">
q-modal(
  v-model="visible"
  minimized
  no-backdrop-dismiss
)
  .q-pa-lg(style="width: 500px")
    q-field.people-detail-field.q-mb-md(
      :error="errors.name !== false"
      :error-label="errors.name || ''"
    )
      q-input(
        ref="focus"
        v-model.trim="data.name"
        :disable="!data.writable"
        data-lpignore="true"
        float-label="氏名"
      )

    q-field.people-detail-field.q-mb-md(
      :error="errors.short_name !== false"
      :error-label="errors.short_name || ''"
    )
      q-input(
        ref="focus2"
        v-model.trim="data.short_name"
        data-lpignore="true"
        float-label="氏名(短縮形)"
      )

    q-field.people-detail-field.q-mb-md(
      :error="errors.group !== false"
      :error-label="errors.group || ''"
    )
      q-input(
        v-model.trim="data.group"
        float-label="グループ"
        type="number"
        @keydown="preventIllegalNumberCharacter"
      )

    q-field.people-detail-field.q-mb-md
      q-toggle(
        v-model="data.auto_assign"
        :false-value="0"
        :true-value="1"
      ) レジシフト自動割当

    //- 更新モード
    template(v-if="data.id")
      .flex.justify-end
        q-btn.q-mx-sm(
          :disable="!data.writable"
          color="negative"
          flat
          @click="destroy"
        ) 削除

        q-btn.q-mx-sm(
          color="primary"
          flat
          @click="confirm"
        ) 更新

        q-btn.q-mx-sm(
          color="dark"
          flat
          v-close-overlay
        ) キャンセル

    //- 新規モード
    template(v-else)
      .flex.justify-end
        q-btn.q-mx-sm(
          color="primary"
          flat
          @click="confirm"
        ) 追加

        q-btn.q-mx-sm(
          color="dark"
          flat
          v-close-overlay
        ) キャンセル

</template>

<script>
import {get} from 'lodash-es'

import QSelectMod from 'components/QSelectMod'
import AxiosMixin from 'mixins/axios'

const defaults = {
  id:          null,
  name:        '',
  short_name:  '',
  auto_assign: 0,
  writable:    true,
  group:       0,
}

export default {
  components: {QSelectMod},
  mixins: [AxiosMixin],

  data() {
    return {
      visible:  false,

      data:     {},
      original: null,

      errors: {
        name:       false,
        short_name: false,
        group:      false,
      },
    }
  },

  methods: {

    preventIllegalNumberCharacter(e) {
      if(e.key == 'e') {
        e.preventDefault()
      }
    },

    show(data = {}) {
      this.data = Object.entries(defaults).reduce(
        (a, [k, v]) => ({...a, [k]: get(data, k, v)}), {})
      this.original = {...this.data}

      this.clearError()
      this.visible = true

      setTimeout(() => {
        this.$refs.focus.disable
          ? this.$refs.focus2.focus()
          : this.$refs.focus.focus()
      }, 0)
    },

    hide() {
      this.visible = false
    },

    confirm() {
      this.clearError()
      this.$emit('confirm', this.data)
    },

    async destroy() {
      try {
        await this.$q.dialog({
          title:   '削除の確認',
          message: '「' + this.original.name + '」を削除します。よろしいですか？',
          ok:      {label: '削除',       color: 'negative'},
          cancel:  {label: 'キャンセル', color: 'dark', flat: true},
        })
        this.$emit('delete', this.data)
      }
      catch(e) {this.$handler(e)}
    },

    clearError() {
      this.errors = Object.keys(this.errors).reduce(
        (a, k) => ({...a, [k]: false}), {})
    },

    handler(e) {
      this.$handler(e, errors => {
        this.errors = Object.entries(this.errors).reduce(
          (a, [k, v]) => ({...a, [k]: get(errors, [k, '0'], v)}), {})
      })
    },

  },
}
</script>

<style lang="sass">
.people-detail-field
  height: 5rem
</style>
